import { Box } from "@mui/system";
import { styled } from "@mui/material/styles";

export const CenterFlexBox = styled(Box)({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
});
